import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {LetrusApi} from '@letrustech/letrus-api-interfaces';
import {FinalGradeChart} from 'components/ui';
import React, {useEffect, useState} from 'react';

import {getCompetences} from 'utils/functions/ReviewSideBar';
import {
  CompositionDetailExtended,
  CompositionReviewDetailExtended,
} from 'utils/types/compositions';
import AchievementsGrade from './AchievementsGrade';
import Competences from './Competences';
import styles from './ReviewSidebar.module.scss';
import Standards from './Standards';

export interface ReviewSideBarProps {
  review?: ImmutableMap<CompositionReviewDetailExtended>;
  genre?: ImmutableMap<LetrusApi.Genre>;
  toggleFullsideBar?: () => void;
  cycleType?: number;
  isFundII?: boolean;
  composition?: ImmutableMap<CompositionDetailExtended>;
  noHeader?: boolean;
  expand?: boolean;
  onUnload?(): void;
}

export interface MappedCompetences {
  name: string;
  level: number;
  score: number;
  maxScore: number;
  comments?: string;
  gradeId?: number;
  likeInfo?: boolean;
  studentCompetenceDescription: string;
  studentCompetenceDescriptionCycleOne: string;
  description: string;
  standards: string;
  scoreDisplay: string;
  id?: number;
}

const ReviewSidebar: React.FC<ReviewSideBarProps> = ({
  onUnload,
  review,
  genre,
  toggleFullsideBar,
  cycleType,
  isFundII,
  composition,
  noHeader,
  expand,
}) => {
  const [competences, setCompetences] = useState<MappedCompetences[]>([]);

  const GU_ZERO_REASON_IDS = [12, 13, 14];
  const isGUZeroed = GU_ZERO_REASON_IDS.includes(
    review?.get('zero_grade_reason') ?? 0,
  );

  useEffect(() => {
    if (!genre || !review) return;
    setCompetences(getCompetences(genre, review));
  }, [genre, review]);

  useEffect(() => {
    return () => {
      onUnload?.();
    };
  }, []);

  return (
    <>
      {!review?.size || !genre ? (
        <div style={{padding: '0 30px'}} className="reviewSidebar">
          Carregando...
        </div>
      ) : (
        <section className={styles.wrapper}>
          <div
            className={`${styles.competences} ${
              expand ? styles.noPadding : ''
            }`}
          >
            {!noHeader && (
              <div className={styles.competencesHeader}>
                <h1 className={styles.competencesTitle}>
                  {isFundII ? 'Conceito' : 'Competências'}
                </h1>

                <button
                  className={styles.expandMenuButton}
                  type="button"
                  onClick={toggleFullsideBar}
                >
                  <FontAwesomeIcon icon="expand-arrows-alt" />
                </button>
              </div>
            )}
            {isFundII ? (
              <>
                <AchievementsGrade
                  cycleType={cycleType}
                  genre={genre}
                  review={review}
                  competences={competences}
                />
                <Standards
                  competences={competences}
                  cycleType={cycleType}
                  showComments={!isGUZeroed}
                />
              </>
            ) : (
              <>
                <div className={styles.chart}>
                  <FinalGradeChart size={240} competences={competences} />
                </div>

                <Competences
                  review={review}
                  competences={competences}
                  composition={composition}
                  expand={expand}
                />
              </>
            )}
          </div>
        </section>
      )}
    </>
  );
};

export default ReviewSidebar;
